<app-admin-page-model routeName="Ajout d'utilisateurs" pageTitle="Liste des demandes d'ajout d'utilisateur">
  <app-user-requests [requests]="requests"/>
</app-admin-page-model>
